import React from 'react';
import BlueTopPage from '../BlueTopPage';
import ErrorBody from '../ErrorBody';

/**
 * Full-page error treatment: the error body inside the standard blue-top page.
 *
 * Used by the root boundary, which sits outside the sidebar shell and therefore
 * has to supply a whole page. Routes inside the shell use ErrorBody directly.
 */
const ErrorBoundaryComponent = ({ error }: { error: unknown }) => (
  <BlueTopPage title="Oh-oh! Something went wrong" description="">
    <ErrorBody error={error} hardReload />
  </BlueTopPage>
);

export default ErrorBoundaryComponent;
